import React, {useEffect, useState} from "react";
import "./ContactUs.scss";
import {useFixedHeader} from "../../../../utils/headerHelper";
import {SubmitInfo} from "../../../../components/SubmitInfo/SubmitInfo";
import {BlackModal} from "../../../../components/BlackModal/BlackModal";
import {FooterFixed} from "../../../../components/FooterFixed";
import {WeChatQR} from "../../../../components/WeChatQR";
import anlei from "../../imgs/an-qr.jpg";
import yecuijuan from "../../imgs/ye-qr.jpg";
import reborn from "../../imgs/after-service-qr.jpg";
import qr from "../../imgs/pb-qr.png";
import intl from "react-intl-universal";
import {DEFAULT_LOCALE, ENGLISH_LOCALE, LOCALES_HELPER} from "../../../../locales/config";

const MAP_TOOL = {
    [DEFAULT_LOCALE]: 'zh_cn',
    [ENGLISH_LOCALE]: 'en'
}
export function ContactUs() {
    const lang = LOCALES_HELPER.getLan();

    useFixedHeader();
    const [showQR, setShowQR] = useState(false);


    // 构造点标记
    let marker = new window.AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [113.587800,22.771950]
    });
// // 构造矢量圆形
//     let circle = new window.AMap.Circle({
//         center: new window.AMap.LngLat("113.588078","22.772109"), // 圆心位置
//         radius: 100,  //半径
//         strokeColor: "#F33",  //线颜色
//         strokeOpacity: 1,  //线透明度
//         strokeWeight: 3,  //线粗细度
//         fillColor: "#ee2200",  //填充颜色
//         fillOpacity: 0.35 //填充透明度
//     });

    useEffect(()=>{
        //初始化地图
        let map = new window.AMap.Map('map-container', {
            resizeEnable: true,
            zoom: 20, //初始地图级别
            center: [113.588078,22.772109], //初始地图中心点
            lang: MAP_TOOL[lang] //可选值：en，zh_en, zh_cn
        });
        map.add(marker);
    }, [])

    return <>
        <main className="main-content">
            <header
                className="page-header large image-background about-us-header-bg dark-color center no-padding"
                data-stellar-background-ratio="0.3">
                    <div className="container v-align-center">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="x-large">{intl.get('contactUs')}</h1>
                                <div>
                                    <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i>
                                </div>
                            </div>
                        </div>
                    </div>
            </header>

            <div className="contact-wrapper">
                <div className="ny_contact w">
                    <div className="con_txt fl">
                        <h1>{intl.get('contactUs')}</h1>
                        <p>{intl.get('c-desc')}</p>

                        <ul>
                            <li><span className="icon-glyph-163 font-20 fl"></span>
                                <div className="fl">
                                    <h3>{intl.get('addr')}</h3>
                                    <p>{intl.get('addr-detail')}</p>
                                </div>
                            </li>
                            <li><span className="icon-glyph-2 fl font-20"></span>
                                <div className="fl">
                                    <h3>{intl.get('owner')}</h3>
                                    <p> {intl.get('owner-phone')}<br/>
                                        {intl.get('email_')}：anlei@rebornendo.com<br/>
                                        {intl.get('weixin_')}：<WeChatQR qr={anlei}/>
                                    </p>
                                </div>
                            </li>
                            <li><span className="icon-glyph-194 fl font-20"></span>
                                <div className="fl">
                                    <h3>{intl.get('gn')}</h3>
                                    <p>
                                        {intl.get('gn-phone')}<br/>
                                        {intl.get('email_')}：sales4@rebornendo.com<br/>
                                        {intl.get('weixin_')}：<WeChatQR qr={anlei}/>
                                    </p>
                                </div>
                            </li>
                            <li><span className="icon-glyph-70 fl font-20"></span>
                                <div className="fl">
                                    <h3>{intl.get('gw')}</h3>
                                    <p>
                                        {intl.get('gw-phone')}<br/>
                                        {intl.get('email_')}：sales4@rebornendo.com<br/>
                                        {intl.get('weixin_')}：<WeChatQR qr={reborn}/>
                                    </p>
                                </div>
                            </li>
                            <li><span className="icon-glyph-104 fl font-20"></span>
                                <div className="fl">
                                    <h3>{intl.get('shrx')}</h3>
                                    <p>（+86）15360880199    <WeChatQR qr={reborn}/></p>
                                </div>
                            </li>
                            <li><span className="icon-glyph-284 fl font-20"></span>
                                <div className="fl">
                                    <h3>{intl.get('gzsj')}</h3>
                                    <p>8:00-12:00 14:00-18:00</p>
                                </div>
                            </li>


                        </ul>
                    </div>
                    <div className="contact_book">
                        <h2>{intl.get('zxly')}</h2>
                        <form id="contact_form" className="contact_form wpcf7-form nice-validator n-yellow"
                              name="contact_form" method="post" noValidate="novalidate">

                            <div className="input" style={{marginRight: "22px"}}><input type="text" name="t1" size="40"
                                                                                        aria-required="true"
                                                                                        aria-invalid="false"
                                                                                        placeholder={intl.get('name')}/>
                            </div>
                            <div className="input"><input type="email" name="t3" size="40" aria-required="true"
                                                          aria-invalid="false" placeholder={intl.get('email')}/></div>
                            <div className="input" style={{marginRight: "22px"}}><input type="text" name="t2" size="40"
                                                                                        aria-invalid="false"
                                                                                        placeholder={intl.get('phone')}/>
                            </div>
                            <div className="input"><input type="text" name="t0" size="40" aria-invalid="false"
                                                          placeholder={intl.get('notes')}/></div>

                            <div className="content"><textarea name="t4" cols="40" rows="10" aria-invalid="false"
                                                               placeholder={intl.get('contents')}></textarea></div>

                            <div className="submit"><input type="submit" value={intl.get('commit')}
                                                           className="wpcf7-form-control wpcf7-submit fh-btn"/></div>
                        </form>
                    </div>
                </div>
            </div>


            {/*<div className="map-wrapper">*/}
            {/*    <iframe width='1920' height='440' frameBorder='0' scrolling='no' marginHeight='0' marginWidth='0'*/}
            {/*            src='https://surl.amap.com/cVi4gc1gd7j'></iframe>*/}
            {/*</div>*/}
            <div id="map-container" style={{width: '100%', minHeight:'440px'}}></div>


            <SubmitInfo/>
            <BlackModal/>
        </main>
        <FooterFixed/>
        {/*固定二维码*/}
        <div className="fixed-contact-wrapper">
            {/*<div className="tel-wrapper">*/}
            {/*    <div className="font-32 contact-icon" onMouseEnter={() => setShowPhone(true)}*/}
            {/*         onMouseLeave={() => setShowPhone(false)}>*/}
            {/*        <span className="icon-glyph-104"></span>*/}
            {/*    </div>*/}
            {/*    <div className={`hot-phone ${showPhone ? 'active' : ''}`}>*/}
            {/*        24小时售后服务热线：<br/>*/}
            {/*        （+86）15360880199*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="qr-wrapper">
                <div className="font-32 contact-icon" onMouseEnter={() => setShowQR(true)}
                     onMouseLeave={() => setShowQR(false)}>
                    <span className="icon-glyph-143"></span>
                </div>
                <div className={`qr-code ${showQR ? 'active' : ''}`}>
                    <img src={qr}/>
                </div>
            </div>
        </div>
    </>
}
